import styled from 'styled-components';

export const DriverProfileContainer = styled.div`
    margin: ${p => p.margin ? p.margin : ''};
    padding: 2rem 0;
    border-top: solid 1px #f5f5f5;
    h4 {
        margin-bottom: 1.4rem;
    }
    img {
        height: 16px;
        width: 16px;
    }
`;